<template>
  <div class="col-big-vbspace basic-form">
    <div
      v-for="option in options"
      :key="option.shortname"
      class="col-vspace flex-radio"
      :class="{
        'flex-radio--disabled':
          !active || (active && active.shortname !== option.shortname),
      }"
    >
      <div class="flex-radio__input">
        <input
          v-model="active"
          :id="`type-${option.shortname}`"
          :value="option"
          :checked="active && active.shortname === option.shortname"
          type="radio"
          name="custom-option-choice"
        />

        <label
          class="flex-radio__input__box"
          :class="{
            'flex-radio__input__box--checked':
              active && active.shortname === option.shortname,
          }"
          :for="`type-${option.shortname}`"
        />
      </div>
      <div class="flex-radio__data">
        <label class="label--textarea" :for="`type-${option.shortname}`">
          {{ option.label }}

          <span v-if="!Number.isNaN(option.price) && !hidePrice">
            (+ {{ option.price }}&euro;)
          </span>
        </label>

        <BasicPreviewName
          v-if="option.customizable"
          :name="customization"
          :maxLength="option.maxLength"
          acceptSpace
          acceptSpecialChars
          placeholder="Tapez la personnalisation ici..."
          @change-name="changePersonnalisation"
          @handle-error="event => $emit('handle-error', event)"
          @focus="active = option"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BasicPreviewName from './BasicPreviewName.vue';

export default {
  components: {
    BasicPreviewName,
  },

  props: {
    customization: {
      type: String,
      default: 'Widddi',
    },
    options: {
      type: Array,
      default: () => [],
    },
    hidePrice: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      active: null,
    };
  },

  watch: {
    active(value) {
      this.$emit('update', value);
    },
  },

  methods: {
    changePersonnalisation(value) {
      this.$emit('update:customization', value);
    },
  },
};
</script>
